/**
 * What the book keeps on a market. Back every outcome at the prices on offer and the implied
 * probabilities add up to more than one; the excess is the edge. Betfair's ladder is lay prices, which
 * run the other way, so the number lands below zero there — that is the honest reading of a lay market,
 * not a fault in the sum.
 */
export const marginOf = (prices) => {
  const legs = prices.filter((price) => typeof price === 'number' && price > 1)

  // a single leg says nothing: the overround only exists across a whole market
  if (legs.length < 2) {
    return null
  }

  return (legs.reduce((total, price) => total + 1 / price, 0) - 1) * 100
}

export const formatMargin = (margin) => {
  if (margin === null || margin === undefined || !Number.isFinite(margin)) {
    return '—'
  }
  return `${margin < 0 ? '−' : ''}${Math.abs(margin).toFixed(2)}%`
}
